var _path, _path2, _circle, _circle2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultLanguageChallenge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default_language_challenge_svg__clip0_1396_1338)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0h32c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H16C7.163 64 0 56.837 0 48V16z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "M-1-7h80v80H-1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 55,
    r: 40,
    fill: "#D8D8D8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -1,
    cy: 24,
    r: 26,
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -15,
    y: -14,
    width: 94,
    height: 94
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      height: "100%",
      width: "100%"
    },
    clipPath: "url(#default_language_challenge_svg__bgblur_1_1396_1338_clip_path)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 12,
    fill: "#000",
    fillOpacity: 0.24,
    d: "M-3-2h70v70H-3z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "default_language_challenge_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 17,
    width: 32,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M16 17h32v32H16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#default_language_challenge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.497 41.6l-1.274 3.438a.975.975 0 01-.358.453.952.952 0 01-.56.176.966.966 0 01-.82-.422c-.205-.281-.24-.589-.106-.922l5.183-13.374c.085-.185.209-.334.371-.446a.928.928 0 01.541-.17h.744c.198 0 .379.057.541.17.162.112.286.261.372.446l5.182 13.395c.135.32.103.62-.095.9a.94.94 0 01-.81.423.94.94 0 01-.571-.176 1.122 1.122 0 01-.368-.473L42.195 41.6h-6.698zm-7.52-6.48l-5.928 5.921a.946.946 0 01-.686.3.95.95 0 01-.72-.3.957.957 0 01-.289-.703c0-.275.097-.509.29-.702l5.928-5.941c-.77-.778-1.5-1.7-2.194-2.77a19.338 19.338 0 01-1.711-3.258h2.12a18.13 18.13 0 001.404 2.42c.551.807 1.147 1.541 1.786 2.203.947-.956 1.843-2.116 2.687-3.481.845-1.365 1.441-2.635 1.79-3.809H19.256a.967.967 0 01-.712-.287.967.967 0 01-.288-.713c0-.284.096-.521.288-.713a.967.967 0 01.712-.287H27v-1.154c0-.284.096-.521.287-.713a.968.968 0 01.713-.287c.284 0 .521.096.713.287.191.192.287.43.287.713V23h7.744c.284 0 .521.096.712.287a.967.967 0 01.288.713.967.967 0 01-.288.713.967.967 0 01-.712.287h-2.265c-.432 1.497-1.121 3.063-2.067 4.696-.947 1.633-1.956 2.98-3.03 4.04l3.29 3.369-.757 2.054-3.938-4.039zm8.161 4.71h5.416l-2.708-7.274-2.708 7.275z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "default_language_challenge_svg__bgblur_1_1396_1338_clip_path",
    transform: "translate(15 14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-2h70v70H-3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "default_language_challenge_svg__clip0_1396_1338"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0h32c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H16C7.163 64 0 56.837 0 48V16z",
    fill: "#fff"
  })))));
}
export default __webpack_public_path__ + "assets/static/media/default_language_challenge.4073a88f.svg";
export { SvgDefaultLanguageChallenge as ReactComponent };